'use client'

import { Icon } from '@components/primitives/Icon'
import Link from '@components/primitives/Link'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faHouseMedical } from '@fortawesome/pro-regular-svg-icons/faHouseMedical'
import DynamicRoutes from '@lib/routes/DynamicRoutes'
import type { HospitalPageData } from '@modules/hospitals/cache/getCachedHospitalPageData'
import 'maplibre-gl/dist/maplibre-gl.css'
import { Marker } from 'react-map-gl/dist/es5'

export const HospitalLocationPin = ({
  highlighted,
  hospital,
  onMouseEnter,
  onMouseLeave,
}: {
  highlighted: boolean
  hospital: HospitalPageData['similarHospitalsNearby'][0]
  onMouseEnter: () => void
  onMouseLeave: () => void
}) => {
  const lat = parseFloat(hospital.zipcode?.lat ?? '')
  const lng = parseFloat(hospital.zipcode?.lng ?? '')

  return (
    <Marker
      anchor='top'
      latitude={lat}
      longitude={lng}
      style={{ zIndex: highlighted ? '1' : 'unset' }}
    >
      <Link href={DynamicRoutes.center(hospital.slug)}>
        <div
          className={classMerge(
            'mt-0 flex w-96 max-w-prose flex-col gap-y-3 text-center',
          )}
        >
          <div
            className='relative'
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          >
            <Icon
              className={classMerge(
                'cursor-pointer rounded-lg p-2 hover:bg-primary500 hover:text-white hover:drop-shadow-xl',
                highlighted
                  ? 'bg-primary500 text-white'
                  : 'bg-white text-primary500',
              )}
              icon={faHouseMedical}
              size='2x'
            />
          </div>
          {highlighted && (
            <div className='flex flex-col items-center justify-center gap-y-1 rounded-2xl bg-white py-2'>
              <div className='flex flex-col items-center justify-start gap-y-1'>
                <Text styleName='p-small-strong'>{hospital.name}</Text>
                <Text className='text-neutral600' styleName='p-small'>
                  {hospital.trialCount?.toLocaleString()} trials
                </Text>
              </div>
            </div>
          )}
        </div>
      </Link>
    </Marker>
  )
}
